// TODO: this might have to be moved to a common place where to access from the pages that need it.
import { getSdk } from "../services/sdkService";
import { i18n } from "../services/i18nService";
import { getUserMediaLists, checkHistoryProgress } from "../services/mediaListService";
import { getEpisodeLabel } from "../services/copyService";
import { isSuitableFor4KPlayback,  getTrailer } from "../services/titleDataService";
import { redirectTo } from "../services/navigationService";
import isSeries from "../utils/isSeries";
import { routes } from "../routes";
import { getFVODTitlesFormattedForEpisodes } from "./fvodUtils";

let seasonsList;
let episodesList;
let lastEpisodeData;

const HISTORY_LIST = "historylist";
const WATCH_LIST = "watchlist";

/**
 * This method is used when reproducing content either from Layout or MyLibrary.
 */
export async function play(is4K, data, extra = {}) {
  const { id, progress, seriesId, moduleId } = this.videoConfig;
  if (this.playFromLabel === "cw_home") {
    redirectTo.call(this, routes.player, {
      playFrom: this.playFromLabel,
      videoConfig: { id, progress, seriesId, moduleId, is4K },
      ...extra,
      isFreeToAir: data?.isFreeContent || false
    });
  } else {
    const videoData = await getVideoData.call(this, id, progress, seriesId, moduleId, is4K, data);
    sessionStorage && sessionStorage.setItem("seriesPlaying4K", is4K);
    this.state.didPlayerLaunch &&
      redirectTo.call(this, routes.player, {
        ...videoData,
        ...(this.playFromLabel && { playFrom: this.playFromLabel }),
        ...extra,
        isFreeToAir: data?.isFreeContent || false
      });
  }
}

/**
 * This method is used when reproducing content either from Layout or MyLibrary.
 */
export async function playHandler(data, extra) {
  if (isSuitableFor4KPlayback(this.videoConfig.titleId4K)) {
    this.setState({ modal4K: true }, () => {
      this.play4KModalFocusPath && this.play4KModalFocusPath.props.setFocus();
    });
  } else {
    this.props.pauseNavigation();
    this.setState({ didPlayerLaunch: true });
    play.call(this, false, data, extra);
  }
}

function getPlaybackTime(progress) {
  return progress.playbackTime || 0;
}

/**
 * Builds an object to be passed to the player with the Trailer for the selected title data.
 * @param {String} titleId  - Title (movie/episode) ID.
 * @param {Object} progress - Title (movie/episode) progress data.
 * @param {String} seriesId - Series ID.
 * @param {String} moduleId - Module ID for use it on send user events.
 * @param {String} is4K     - The quality is 4k.
 */
export async function getTrailerVideoData(titleId, moduleId, is4K, data = null) {
  let videoTitle = data;
  if (!videoTitle || is4K) {
    const sdk = await getSdk();
    videoTitle = await sdk.mediaManager.getTitle(titleId, { is4K });
  } 
  videoTitle['manifest']= await getTrailer(videoTitle);
  const {
    id,
    mediaContent,
    title,
    addonContent,
    manifest,
    has4K
  } = videoTitle;

  return {
    id,
    mediaContent,
    title,
    manifest,
    addonContent,
    moduleId,
    has4K,
   }

}
/**
 * Builds an object to be passed to the player with the watchlist selected title data.
 * This method is used when reproducing content either from Layout or MyLibrary.
 * @param {String} titleId  - Title (movie/episode) ID.
 * @param {Object} progress - Title (movie/episode) progress data.
 * @param {String} seriesId - Series ID.
 * @param {String} moduleId - Module ID for use it on send user events.
 * @param {String} is4K     - The quality is 4k.
 */
export async function getVideoData(titleId, progress, seriesId, moduleId, is4K, data = null) {
  let videoTitle = data;
  if (!videoTitle || is4K) {
    const sdk = await getSdk();
    videoTitle = await sdk.mediaManager.getTitle(titleId, { is4K });
  }
  const {
    id,
    mediaContent,
    title,
    shortDescription,
    description,
    tagList,
    tvSeasonEpisodeNumber,
    tvSeasonNumber,
    title4K,
    addonContent,
    isLive
  } = videoTitle;

  const videoType = isSeries(tagList["categories"]) ||  videoTitle?.seriesId ? "series" : "movie";
  const videoGenre = tagList["genres"] ? tagList.genres[0] : null;
  const has4K = is4K && !!title4K;
  const media = has4K ? title4K.mediaContent[0] : mediaContent[0];
  const video = media.content.video;
  return {
    addonContent,
    isLive,
    videoType,
    title,
    genre: videoGenre,
    description: shortDescription || description,
    manifest: video.streamingUrl,
    releasePid: video.releasePid,
    releaseUrl: video.releaseUrl,
    duration: video.duration,
    filmstrip: media.content.filmstrip,
    playbackTime: progress && getPlaybackTime(progress),
    id,
    moduleId,
    has4K,
    //externalSubtitles: has4K && media.content.subtitles,
    externalSubtitles: media.content.subtitles,
    mediaGuid: media.mediaGuid,
    credits: media.credits,
    ...(tvSeasonEpisodeNumber &&
      tvSeasonNumber && {
        tvSeasonEpisodeNumber,
        tvSeasonNumber,
        episodeLabel: getEpisodeLabel(tvSeasonNumber, tvSeasonEpisodeNumber),
        seriesId
      })
  };
}

/**
 * Gets series general data and builds an object to be passed to the player about
 * its seasons and episodes information.
 * @param {String} seriesId - Series ID.
 * @param {Boolean} needsLastEpisodeData.
 */
export async function getSeasonsAndEpisodesList(seriesId, needsLastEpisodeData) {
  await getSeasons(seriesId);
  return {
    episodesList: await getEpisodes(seriesId),
    seasonsList: recheckSeasonsEpisodes(formatSeasonsNumber(seasonsList), episodesList),
    ...(needsLastEpisodeData && { lastEpisode: lastEpisodeData })
  };
}

/**
 * Checks series seasons list once episodes list is retrieved to make sure to get all seasons
 * that have episodes related.
 * @param {Array} seasonsList - Array containing all seasons, formatted.
 * @param {Array} episodesList - Array containing all episodes.
 */
export function recheckSeasonsEpisodes(seasonsList, episodesList) {
  let formattedSeasonList = [];
  if (seasonsList && seasonsList.length && episodesList && episodesList.length) {
    for (let formattedSeason of seasonsList) {
      episodesList.find(episode => episode.tvSeasonNumber === formattedSeason.number) &&
        formattedSeasonList.push(formattedSeason);
    }
    return formattedSeasonList;
  }
  return seasonsList;
}

/**
 * Gets and formats seasons list to be passed to the player.
 * @param {String} seriesId - Series ID.
 */
async function getSeasons(seriesId) {
  const sdk = await getSdk();
  try {
    seasonsList = await sdk.mediaManager.getSeriesSeasonsList(seriesId);
  } catch (e) {
    return [];
  }
}

/**
 * Format seasons list to be passed to the player.
 */
export function formatSeasonsNumber(seasonsObject) {
  const seasonsArray = [];
  for (let season of seasonsObject) {
    seasonsArray.push({
      title: `${i18n.get("global.media.season")} ${season.tvSeasonNumber}`,
      number: season.tvSeasonNumber
    });
  }
  return seasonsArray;
}

/**
 * Gets all seasons episodes and checks if series has ever been watched to inject data from historyList.
 * @param {String} seriesId - seriesId
 */
async function getEpisodes(seriesId) {
  episodesList = await getEpisodesData(seriesId, seasonsList);
  return await getUserMediaLists(seriesId, checkMediaListsData);
}

/**
 * Creates an array which gathers each and every episode of the series.
 * @param {String} titleId - Title ID.
 * @param {Array} seasonsList - Array of seasons objects.
 */
export async function getEpisodesData(titleId, seasonsList) {
  const sdk = await getSdk();
  const seasonsEpisodes = seasonsList.map(
    async season => await sdk.mediaManager.getSeriesSeasonEpisodes(titleId, season.tvSeasonNumber)
  );
  const episodesArray = await seasonsEpisodes.reduce(async (acc, curr) => {
    try {
      return (await acc).concat(await curr);
    } catch (e) {
      return (await acc).concat([]);
    }
  }, []);
  
  // set isFreeContent to episodesList. This helps in adding tags later
  getFVODTitlesFormattedForEpisodes(episodesArray)

  return includeEpisodesDurationText(episodesArray);
}

/**
 * Includes an extra field providing the combination of its video content duration and the proper
 * time measurement label (in the app selected language) to every episode from the episodes array.
 * @param {Array} episodesArray - Episodes array.
 */
function includeEpisodesDurationText(episodesArray) {
  return episodesArray.map(episode => ({
    ...episode,
    ...(episode.mediaContent[0].content.video.duration && {
      durationText: `${Math.floor(episode.mediaContent[0].content.video.duration / 60)} ${i18n.get(
        "pages.detail.mins"
      )}`
    })
  }));
}

/**
 * Checks data present in mediaLists array.
 * If the title is in historylist but not in watchlist it means that this title has seen to the end
 * and the playback time should be 0 in order to start from the beggining
 * @param {Array} mediaLists - Array of media lists objects.
 */
function checkMediaListsData(mediaLists) {
  const historyList = mediaLists.filter(list => list.name === HISTORY_LIST);
  const watchList = mediaLists.filter(list => list.name === WATCH_LIST);
  const episodes =
    episodesList &&
    episodesList.length &&
    historyList.length &&
    checkHistoryProgress(episodesList, historyList[0].titles, watchList && watchList.length && watchList[0].titles);

  watchList && watchList.length && (lastEpisodeData = watchList[0].titles[0]);
  return episodes;
}
